module.exports = __webpack_public_path__ + "img/15.36c608ba.jpg";